enum SearchFilterName {
  CAR_TYPE = "carType",
  SUPPLIER = "supplier",
  CAR_MODEL = "carModel",
  RADIUS = "radius",
  DURATION = "duration",
  CAR_CLASS = "carClass",
  DEPOT = "depot",
  SEATS = "seats",
}

export default SearchFilterName;
